import dayjs from 'dayjs';

/**
 * 日付を年月日に変換
 * @param date
 * @param separator
 */
export const formatDateBySeparator = function (date = dayjs(), separator = '-') {
  if (!date) return false;
  try {
    return date.format(`YYYY${separator}MM${separator}DD`);
  } catch (error) {
    return false;
  }
};

export default formatDateBySeparator;
